import { median, avgArr } from '../../utils/format';
import { MetricCard } from './MetricCard';
interface Props {
  ages: number[];
}
export function MedianAgeCard({
  ages
}: Props) {
  return <MetricCard label="Median age" value={`${median(ages)}d`} sub={`mean ${avgArr(ages)}d`} colorClass="c-gold" data-id="element-519" data-mp="1538ujsbxgfo1" />;
}